export default __webpack_public_path__ + "static/media/CCCR.55356cd2.svg";